import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

export default class ModalDeleteCompetition extends Component {
    constructor(props) {
        super(props);

        this.state = {
            competition: null,
            loading: false
        }

        this.deleteOrActiveCompetition = this.deleteOrActiveCompetition.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            competition : props.competition
        })
    }

    deleteOrActiveCompetition() {
        this.setState({
            loading: true
        });
        let obj = { ...this.state.competition };

        // Xử lý flag isCustom khi Custom được chọn
        if (obj.idEvent === "Custom") {
            obj.isCustom = true;
            obj.idEvent = "WebView";
        } else {
            obj.isCustom = false;
        }


        if (obj.idEvent != "RoomEvent" && (
            !obj.timeStart ||
            !obj.timeEnd ||
            !obj.largeBackgroundUrl ||
            !obj.isSendNotification
        )) {
            obj.timeStart = Date.parse(obj.timeStart);
            obj.timeEnd = Date.parse(obj.timeEnd);
            obj.timeSendNotification = Date.parse(obj.timeSendNotification);
        }

        if (obj.idEvent == "TheVoice") {
            obj.timeStartRound1 = Date.parse(obj.timeStartRound1);
            obj.timeEndRound1 = Date.parse(obj.timeEndRound1);
            obj.timeEndRound2 = Date.parse(obj.timeEndRound2);
        } else if (obj.idEvent == "GAME" || obj.idEvent == "WebView") {
            let timeEndRound1 = obj.timeEndRound1;
            obj.timeStartRound1 = Date.parse(obj.timeStartRound1);
            obj.timeEndRound1 = obj.timeStartRound1;
            obj.timeEndRound2 = Date.parse(timeEndRound1);
        }


        obj.timeShowStart = Date.parse(obj.timeShowStart);
        obj.timeShowEnd = Date.parse(obj.timeShowEnd);
    
        obj.stickersDeepAr = [];
        obj.categoryId = +obj.categoryId;
        if (obj.canApplyExaminer === '0') {
            obj.canApplyExaminer = false;
        } else if (obj.canApplyExaminer === '1') {
            obj.canApplyExaminer = true;
        }
       
        obj.hashtags = [];
        const myJSON = JSON.stringify(obj);

        axios.post(global.config.apiDomain + '/rest/theVoiceV2/deleteOrActiveCompetition', myJSON, {
            headers: {
                'Content-Type': 'application/json',
            },
         })
        .then(res => {
            console.log('/rest/theVoiceV2/deleteOrActiveCompetition');
            console.log(res);
            this.setState({
                loading: false
            });

            if (res.data.status == "OK") {
                window.$("#modalDeleteCompetition").modal("hide");
                toast.success(res.data.message); 
                this.props.resetList();
            } else {
                toast.warning(res.data.message);
            }
        }).finally(() => {
            this.setState({
                loading: false
            });
        })
    }

    render() {

        const {competition} = this.state;

        return (
            <div>
                <div className="modal fade" id="modalDeleteCompetition" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                            {(competition && !competition.isRemoveByAdmin) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">XÓA Cuộc thi</h5>
                            ) : ""}
                            {(competition && competition.isRemoveByAdmin) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">HỦY XÓA Cuộc thi</h5>
                            ) : ""}
                               
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {(competition && !competition.isRemoveByAdmin) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-danger">Bạn chắc chắn muốn XÓA Cuộc thi: <span className="font-weight-bold">{competition.name}</span> ?</h3>
                            </div>
                            ) : ""}
                            {(competition && competition.isRemoveByAdmin) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-info">Bạn muốn HỦY XÓA Cuộc thi: <span className="font-weight-bold">{competition.name}</span> ?</h3>
                            </div>
                            ) : ""}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.deleteOrActiveCompetition}>Xác nhận</button>    
                                )}                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}